// extracted by mini-css-extract-plugin
export default {"form":"resource-form_form__pkZAC"};